// extracted by mini-css-extract-plugin
module.exports = {"App":"App__App__2NQx7"};